import React,{useEffect,useState,useCallback} from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios';
import { BASE_URL } from '../Config/Base';
import { Oval } from  'react-loader-spinner'
import _ from 'lodash'

const pageSize = 5;

const TcContentmain=() =>{

  const[about, setAbout] =useState([])
  const[delDetail, setdelDetail] =useState([])
  const[display, setDisplay] =useState(true)
const[edit,setEdit]= useState(true)
const[del,setDel]= useState(true)
const[btn,setBtn]= useState(true)
const[pop,setpop] = useState(false);

const [allusers,setAllusers]= useState([])
const [paginatedPosts, setpaginatedPosts] = useState();
//const [currentPage, setcurrentPage] = useState(1);

useEffect(()=>{
    setpop(true);
   
    getContent();
    document.getElementById('Tc-sectionMain').style.display ="none";
    document.getElementById('ContentTable').style.display ="none";
    document.getElementById('pagination').style.display ="none";

   

    setTimeout(()=>{
        setpop(false);
        document.getElementById('Tc-sectionMain').style.display ="flex";
        document.getElementById('ContentTable').style.display ="flex";
        document.getElementById('pagination').style.display ="block";
      getRoleData()
     // GetTcUserAllRole()
      getUserRole();
    },1000)
    
  },[])

  function getContent(){
   
    fetch('https://localhost:44312/Api/Tc/GetTcUserContent', {
     
    method:'GET',
  
      headers : {
  
        "Content-type": "application/json",
  
        "Accept": "application/json",
  
        //"Authorization": bearer,
  
        "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
      },
  
  //body:JSON.stringify(data)
  
  }).then(response => response.json())
  .then(data => {
  console.log("Data",data)
 
  setAllusers(data)
  setpaginatedPosts(_(data).slice(0).take(pageSize).value());
   localStorage.setItem("TcContentpageData", JSON.stringify(data));
  });
  
  
  }
  // const pageCount = allusers? Math.ceil(allusers.length/pageSize) :0;
  // // if (pageCount === 1)
  // // return null;
  
  // const pages = _.range(1, pageCount+1)
  
  // const pagination =(pageNo)=>{
  // setcurrentPage(pageNo);
  // const startIndex = (pageNo - 1) * pageSize;
  // const paginatedPost = _(allusers).slice(startIndex).take(pageSize).value();
  // setpaginatedPosts(paginatedPost)
  // }
  
  function AddTcuserContent(){
  
  let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
  
  var contentInput = document.getElementById("contentInput").value

   if(!contentInput){
     document.getElementById('TextError').innerHTML="Content Required"
   
   }
   else{
    document.getElementById('TextError').innerHTML=""
 
          const body ={
            content:contentInput,
            createdBy:"1234" 
          
          }
           console.log(body)
            axios({
           
            method:"POST",
             url: `${BASE_URL}/Tc/TcUserContent`,
           //url:"https://localhost:44312/Api/Tc/TcUserContent",
           data:body,
           headers: {
           "Content-Type" : "application/json",
           'Authorization':bearer
           }
    
            })
            .then((response) =>{
              console.log(response.data.status);
              //window.location.reload();
              closeContentForm() 
              if(response.data.status=='Success'){
                document.getElementById('success-notify').style.display = "block"
                 setTimeout(()=>{
                   document.getElementById('success-notify').style.display = "none"
                 },1000)
              }
             // alert("Content Added Successfully")
              getContent() 
              })
              .catch(error => {
                console.log(error);
               //alert("Content Added Failed !")
               document.getElementById('error-notify').style.display = "block"
               setTimeout(()=>{
                 document.getElementById('error-notify').style.display = "none"
               },1000)
           document.getElementById("reset").reset()
              })
     }
            } 
          
  
   function openContentForm()
   {
   document.getElementById("tcContentForm").style.display = "block";
   
        }
  // close ADD FORM function 
  function closeContentForm()
  {
  
  document.getElementById("tcContentForm").style.display = "none";
  document.getElementById("contentreset").reset();
   document.getElementById('TextError').innerHTML = ""
   document.getElementById("reset").reset();
  
  }
  
  
  function getEditContent(Id){
  
    let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
    
    document.getElementById("tcContenteditForm").style.display = "block";
  
   const body ={
    
    id:Id
  
   }
   console.log(body);
  
  
    axios({          
       method: "POST", 
       //url: `${BASE_URL}/Tc/EditSection`,      
       url: "https://localhost:44312/Api/Tc/EditTcUserContent",
       data:body,
       headers: {             
         'Content-Type': 'application/json' , 
         'Authorization':bearer     
       }
     
     })
     .then((response) =>{
      console.log(response.data);
      setAbout(response.data)
 
       }) 
     
   
  } 
  
  
  // close ADD FORM function 
  function closeContentEditForm()
  {
  
  document.getElementById("tcContenteditForm").style.display = "none";
  document.getElementById("contentreset").reset();
   document.getElementById('editError').innerHTML = ""
  
  }
  
  function handlechange(){
     var InputA = document.getElementById("contentInputA").value;
    
  if (!InputA){
      document.getElementById('editError').innerHTML = "Content Required"
  }
  else{
     document.getElementById('editError').innerHTML = ""
  }
  }


  function updateContent(Id){
  
    var InputA = document.getElementById("contentInputA").value;
    
  if (!InputA){
      document.getElementById('editError').innerHTML = "Content Required"
  }
  else{
     document.getElementById('editError').innerHTML = ""
    const body ={
    
      content:InputA,
      
      id:Id,
      editedBy:"1234" 
    
     }
     console.log(body);
    
     let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
      axios({          
         method: "POST", 
         //url: `${BASE_URL}/Tc/EditSection`,      
         url: "https://localhost:44312/Api/Tc/UpdateTcUserContent",
         data:body,
         headers: {             
           'Content-Type': 'application/json' , 
           'Authorization':bearer     
         }
       
       })
       .then((response) =>{
        console.log(response.data.status);
        closeContentEditForm()
         if(response.data.status=='Success'){
              document.getElementById('edit-notify').style.display = "block"
               setTimeout(()=>{
                 document.getElementById('edit-notify').style.display = "none"
               },1000)
            }
        //alert("Content Updated Successfully") 
             getContent()
         }) 
        }
  }
  
  
  function delContent(Id){
    let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
   
    const body ={
      id:Id
    }
     console.log(body)
      axios({
     
      method:"POST",
       //url: `${BASE_URL}/Tc/Sectiondelete`,
     url:"https://localhost:44312/Api/Tc/DeleteTcUserContent",
     data:body,
     headers: {
     "Content-Type" : "application/json",
     'Authorization':bearer
     }
  
      })
      .then((response) =>{
        console.log(response.data);
        if(response.data.status=='Success'){
          document.getElementById('del-notify').style.display = "block"
           setTimeout(()=>{
             document.getElementById('del-notify').style.display = "none"
           },1000)
        }
      
    
       //alert("Content Deleted Successfully")
         getContent() 
         document.getElementById("modalDeleteForm").style.display = "none"; 
  
       
        })
    }
  function getdelDetails(Id){

    let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
   
   const body ={
    
    id:Id
  
   }
   console.log(body);
  
  
    axios({          
       method: "POST", 
       //url: `${BASE_URL}/Tc/EditSection`,      
       url: "https://localhost:44312/Api/Tc/GetTcContent",
       data:body,
       headers: {             
         'Content-Type': 'application/json' , 
         'Authorization':bearer     
       }
     
     })
     .then((response) =>{
      console.log(response.data);
      setdelDetail(response.data)
  
       }) 
  
  } 


  function ConfirmDelete(Id){

    document.getElementById("modalDeleteForm").style.display = "block";
    getdelDetails(Id)
  
  }


  function closedelForm()
  {
     document.getElementById("modalDeleteForm").style.display = "none";
   
   }
  
  
  function Cancel() {
  document.getElementById("modalDeleteForm").style.display = "none";      
  
     }
  
     function getRoleData(){
      let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
      
     let UserRole =  localStorage.getItem("Role");
    
     const body ={
      
      role:UserRole
    
     }
     console.log(body);
    
    
      axios({          
         method: "POST", 
         //url: `${BASE_URL}/Tc/EditSection`,      
         url: "https://localhost:44312/Api/Tc/GetTcloginUserRole",
         data:body,
         headers: {             
           'Content-Type': 'application/json' , 
           'Authorization':bearer     
         }
       
       })
       .then((response) =>{
        console.log(response.data);
        localStorage.setItem("loginUserRoleaction", JSON.stringify(response.data));
        
         }) 
       
        }
  
      
        // function GetTcUserAllRole(){
        //   fetch('https://localhost:44312/Api/Tc/GetTcUserAllRole', {
        //     method:'GET',
        //     headers : {
      
        //       "Content-type": "application/json",
      
        //       "Accept": "application/json",
        
        //      // "Authorization": "Bearer " + `${token}`,
        
        //       "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
        //     },
      
        //     //body:JSON.stringify(data)
      
        //   })
        //    .then(response => response.json())
        //   .then(data => {
        //     console.log(data)         
        //     localStorage.setItem("RoleData", JSON.stringify(data));
          
        //   });
        // }
  
     function getUserRole(){
  
      /**----getroleAction---- */
  let Tcrole =  localStorage.getItem("loginUserRoleaction");
  let roledata =  JSON.parse(Tcrole);
  let role = roledata.map((e)=>e.roleAction);
  console.log(role);
  
  let roles = role.toString();
  let Add = roles.includes('Add')
  console.log(Add)
  
  let View = roles.includes('View')
  console.log(View)
  
  let Edit = roles.includes('Edit')
  console.log(Edit)
  
  let Delete = roles.includes('Delete')
  console.log(Delete)
  
  let empty = roles.includes('')
  console.log(empty)

  let roleid = localStorage.getItem('RoleId')
let id = roleid.includes('01')
console.log(id)
  
   /**----- Conditions--- **/

   if(id==true&&empty==true&&Add==false&&View==false&&Edit==false&&Delete==false)
   {
   setEdit(true);
   setDel(true);
   setDisplay(true); 
   document.getElementById('ActionData').style.display ="block";
   document.getElementById('TCAboutusbtn').style.display ="block";
   document.getElementById('action-err').innerHTML = ''
   }
   if(id==false&&empty==true&&Add==false&&View==false&&Edit==false&&Delete==false)
   {
    setEdit(false);
    setDel(false);
    document.getElementById('TCAboutusbtn').style.display ="none";
    document.getElementById('action-err').innerHTML = 'No Task Assign'
    document.getElementById('ContentTable').style.display ="none";
    document.getElementById('pagination').style.display ="none";
   }
  
  if(Add==true&&View==false&&Edit==true&&Delete==true){
    setEdit(true);
    setDel(true);
    setDisplay(true); 
    document.getElementById('TCAboutusbtn').style.display ="block";
    document.getElementById('ContentAction').style.display ="block";
  }
  if(Add==true&&View==true&&Edit==true&&Delete==true){
    setEdit(true);
    setDel(true);
    setDisplay(true); 
    document.getElementById('TCAboutusbtn').style.display ="block";   
    document.getElementById('ContentAction').style.display ="block";
  }
  if(Add==true&&View==false&&Edit==true&&Delete==false){
    setDel(false);
    setEdit(true);
    setDisplay(true);  
    document.getElementById('TCAboutusbtn').style.display ="block";   
    document.getElementById('ContentAction').style.display ="block";
  }
  if(Add==true&&View==false&&Edit==false&&Delete==true){
    setDel(true);
   setEdit(false);
    setDisplay(true);  
    document.getElementById('TCAboutusbtn').style.display ="block";   
    document.getElementById('ContentAction').style.display ="block";
  }      
 
 if (Add==false&&View==true&&Edit==false&&Delete==false){
  setDisplay(false);
  document.getElementById('TCAboutusbtn').style.display = "none";

 }
      
      if( Add==false&&View==false&&Edit==true&&Delete==false){
        
        setDel(false); 
        document.getElementById('TCAboutusbtn').style.display ="none";
         }
        
         if(Add==false&&View==false&&Edit==false&&Delete==true){
          setEdit(false); 
          document.getElementById('TCAboutusbtn').style.display ="none";
         
           }
          
      if(Add==false&&View==false&&Edit==true&&Delete==true){
        setEdit(true);
        setDel(true);
        setDisplay(true); 
        document.getElementById('TCAboutusbtn').style.display ="none";    
        document.getElementById('ContentAction').style.display ="block";
     }
     if(Add==true&&View==true&&Edit==false&&Delete==false){
      setEdit(false);
      setDel(false);
      setDisplay(false); 
      document.getElementById('TCAboutusbtn').style.display ="block";
      
   }

   if( Add==true&&View==false&&Edit==false&&Delete==false){
 
    document.getElementById('TCAboutusbtn').style.display ="block";
    document.getElementById('ContentTable').style.display ="none";
    document.getElementById('pagination').style.display ="none";
  }
  if( Add==false&&View==true&&Edit==false&&Delete==true){
    setEdit(false); 
    setDel(true); 
    document.getElementById('TCAboutusbtn').style.display ="none";
     }
     if( Add==false&&View==true&&Edit==true&&Delete==false){
      setEdit(true); 
      setDel(false); 
      document.getElementById('TCAboutusbtn').style.display ="none";
       }
       if( Add==true&&View==true&&Edit==false&&Delete==true){
        setEdit(false); 
        setDel(true); 
        document.getElementById('TCAboutusbtn').style.display ="block";
         }
         if( Add==false&&View==true&&Edit==true&&Delete==true){
          setEdit(true); 
          setDel(true); 
          document.getElementById('TCAboutusbtn').style.display ="none";
           }
           if( Add==true&&View==true&&Edit==true&&Delete==false){
            setEdit(true); 
            setDel(false); 
            document.getElementById('TCAboutusbtn').style.display ="block";
             }
      
    } 

         const LEFT_PAGE = "LEFT";
      const RIGHT_PAGE = "RIGHT";
      const range = (from, to, step = 1) => {
        let i = from;
        const range = [];
      
        while (i <= to) {
          range.push(i);
          i += step;
        }
      
        return range;
      };
      
      const [currentPage, setCurrentPage] = useState(1);
      
 let data =  localStorage.getItem("TcContentpageData")
 let transdata =  JSON.parse(data);
      let NUM_OF_RECORDS = transdata.length;
      let LIMIT = 5;
      
      const onPageChanged = useCallback(
      
        (event, page) => {
          event.preventDefault();
          setCurrentPage(page);
        },
        [setCurrentPage]
        
      );
      
      
      const currentData = transdata.slice(
        (currentPage - 1) * LIMIT,
        (currentPage - 1) * LIMIT + LIMIT
      );
      
      const Paginations = (props) => {
        const {
          totalRecords,
          pageLimit,
          pageNeighbours,
          onPageChanged,
          currentPage
        } = props;
        const [totalPages, setTotalPages] = useState(0);
        useEffect(() => {
          setTotalPages(Math.ceil(totalRecords / pageLimit));
        }, [setTotalPages]);
      
        const fetchPageNumbers = () => {
          const totalNumbers = pageNeighbours * 2 + 3;
          console.log(totalNumbers)
          console.log(pageNeighbours)
          const totalBlocks = totalNumbers + 2;
          console.log(totalBlocks)
      
          if (totalPages > totalBlocks) {
            const startPage = Math.max(2, currentPage - pageNeighbours);
            const endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);
      
            let pages = range(startPage, endPage);
      
            const hasLeftSpill = startPage > 2;
            const hasRightSpill = totalPages - endPage > 1;
            const spillOffset = totalNumbers - (pages.length + 1);
      
            switch (true) {
              case hasLeftSpill && !hasRightSpill: {
                const extraPages = range(startPage - spillOffset, startPage - 1);
                pages = [LEFT_PAGE, ...extraPages, ...pages];
                break;
              }
              case hasLeftSpill && hasRightSpill:
              default: {
                pages = [LEFT_PAGE, ...pages, RIGHT_PAGE];
                break;
              }
            }
            return [1, ...pages, totalPages];
          }
          return range(1, totalPages);
        };
      
      
        const pages = fetchPageNumbers() || [];
        return (
          <nav aria-label="Countries Pagination">
            <ul className="pagination">
              {pages.map((page, index) => {
                if (page === LEFT_PAGE)
                  return (
                    <li key={index} className="page-item">
                      <a
                        href="/"
                        className="page-link"
                        aria-label="Previous"
                        onClick={(e) => onPageChanged(e, pageNeighbours * 2 - 1)}
                      >
                        <span aria-hidden="true">&laquo;</span>
                      </a>
                    </li>
                  );
      
                if (page === RIGHT_PAGE)
                  return (
                    <li key={index} className="page-item">
                      <a
                        className="page-link"
                        href="/"
                        aria-label="Next"
                        onClick={(e) => onPageChanged(e, pageNeighbours * 2 + 3)}
                      >
                        <span aria-hidden="true">&raquo;</span>
                      </a>
                    </li>
                  );
      
                return (
                  <li
                    key={index}
                    className={`Tc-page-item${currentPage === page ? " active" : ""}`}
                  >
                    <a
                      className="page-link"
                      href="/"
                      onClick={(e) => onPageChanged(e, page)}
                    >
                      {page}
                    </a>
                  </li>
                );
              })}
            </ul>
          </nav>
        );
      };

  return (
    <div className='TC-addmain'>  
       
    <div className="TC-addgrid-layout">
  <div className="TC-addmain-top">
  <div className='TC-addmain-back'>
    <Link to='/TcAboutus'><i className="fa-sharp fa-solid fa-backward"></i></Link>
    </div> 
    <span> Content </span>
    </div>
    </div>
    <span id='action-err'></span> 
    <div  id='Tc-sectionMain'>
   
    <button class="AddaboutusBtn" id='TCAboutusbtn'><span onClick={openContentForm}><i className="fa-regular fa-square-plus"></i></span><span onClick={openContentForm}>ADD </span></button>
      {/* <button onClick={openContentForm} className='TCAboutusbtn' id='TCcontentbtn'><i className="fa-regular fa-square-plus"></i>&nbsp;&nbsp;ADD</button>  */}
      
      </div>
    
 {/* --- Content table--- */}
 
  <div className='TCtable' id="ContentTable">
     <div class="TC-aboutustable_responsive">
     {
  !paginatedPosts ? (<span style={{display:'flex',justifyContent:'center'}}>No Data Found</span>):(
       <table  className='TC-tblhead' id='TcTable'> 
    <thead>
   <tr>
<th>Content</th>
{display?<th>Action</th>:null}

</tr>
</thead>
<tbody>

{currentData.map((e)=>
{
 
return<tr id='row'>

<td style={{inlineSize:"450px",overflowWrap:"break-word",wordWrap:"break-word"}}>{e.content}</td>

{display?<td style={{inlineSize:"50px",overflowWrap:"break-word",wordWrap:"break-word"}}>{edit?<i  id='Tcediticon' onClick={()=>getEditContent(e.id)} className="fa-regular fa-pen-to-square"></i>:null}&nbsp;&nbsp;&nbsp;

{del?<i className="fa-solid fa-trash" id='Tcdelicon'onClick={()=>ConfirmDelete(e.id)} ></i>:null}<span id='action-err'></span></td>:null}

</tr>

}
)}
</tbody>

</table>
  )}


     </div>
  </div>

  <br></br>  
  <div id='pagination'>
  {
  !paginatedPosts ? (""):(
  <nav id='Tc-Pag'>
    {transdata.length<=5 ? null:<ul className='Tc-pagination'>
       <Paginations
            totalRecords={NUM_OF_RECORDS}
            pageLimit={LIMIT}
            pageNeighbours={2}
            onPageChanged={onPageChanged}
            currentPage={currentPage}
          />

    </ul>}
  </nav>
  )}
  </div>

  
   {/* --- Add form --- */}

<div className='TCpopfade' id="tcContentForm">
  <div className="modal-dialog" role="document">
    <div className="modal-content" id="modal-Popup">
      <div className="modal-header text-center">
      <h4 className="modal-title w-100 font-weight-bold">Add Content</h4>
        <button type="button" className="close"onClick={closeContentForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
     
      <form id="reset">
              <div className="modal-body mx-3">

                  <div className="md-form mb-3">
                  <textarea id='contentInput' placeholder='Text'></textarea>
                  <span id='TextError' className='Tcadduser-error'></span>
                  </div>
                  
                </div>
                  <div className="modal-footer d-flex justify-content-center">
                        <button  className='TC-adduser-button' onClick={AddTcuserContent}>Submit</button>
                  </div>
             </form>

    </div>
  </div>
</div>

<div className='TCpopfade' id='success-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    
    <section class="notif notif-notice" id="successnotif">
             
             <p>Content&nbsp; <span style={{color:"blue"}}>Added</span></p>
             <h6 class="notif-title">Successfully !&nbsp;<i class="fa-solid fa-thumbs-up" style={{fontSize:'25px'}}></i></h6>
          
          </section> 
            
          
    </div>
  </div>
</div>

<div className='TCpopfade' id='error-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    <section class="notif notif-alert" id="errnotify">
      <p>Content&nbsp; Added </p>
      <h6 class="notif-title">Failed !&nbsp;<i class="fa-solid fa-thumbs-down" style={{fontSize:'25px'}}></i></h6>
      
   </section>
    </div>
  </div>
</div>


<div className='TCpopfade' id='edit-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    
    <section class="notif notif-notice" id="successnotif">
             
             <p>Content&nbsp; <span style={{color:"blue"}}>Updated</span></p>
            <h6 class="notif-title">Successfully !&nbsp;<i class="fa-solid fa-thumbs-up" style={{fontSize:'25px'}}></i></h6>
            
          </section>     
          
    </div>
  </div>
</div>
<div className='TCpopfade' id='del-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    
    <section class="notif notif-notice" id="successnotif">
             
             <p>Content&nbsp; <span style={{color:"red"}}>Deleted</span></p>
             <h6 class="notif-title">Successfully !&nbsp;<i class="fa-solid fa-thumbs-up" style={{fontSize:'25px'}}></i></h6>
          </section> 
            
          
    </div>
  </div>
</div>
 {/* --- Edit form --- */}

<form id="contentreset" >
<div className='TCpopfade' id="tcContenteditForm">
  <div className="modal-dialog" role="document">
    <div className="AddRole-edit">
      <div className="modal-header text-center">
      <h4 className="modal-title w-100 font-weight-bold" >Edit Content</h4>
        <button type="button" className="close"onClick={closeContentEditForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
     
      
      {about.map((e)=>
{
return<div>
   <div className="modal-body mx-3">
                  <div className="md-form mb-3">
                  <label>Content</label>
                  <textarea id='contentInputA'  defaultValue={e.content} onKeyUp={handlechange}/>
                  <span id='editError' className='Tcadduser-error'></span>
                  </div>
    
                </div>
                  <div className="modal-footer d-flex justify-content-center">
                  <button className='TC-adduser-button' onClick={()=>updateContent(e.id)}>Update</button>   
                  </div>
 </div>
 }
 )}
 
           

    </div>
  </div>
</div>
</form>


 {/* --- notification popup--- */}

<div className='TCpopfade' id='error-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    <section class="notif notif-alert" id="errnotify">
      <p>Content&nbsp; Added </p>
      <h6 class="notif-title">Failed !</h6>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i class="fa-solid fa-thumbs-down" style={{fontSize:'25px'}}></i>
   </section>
    </div>
  </div>
</div>


<div className='TCpopfade' id='edit-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    
    <section class="notif notif-notice" id="successnotif">
             
             <p>Content&nbsp; Updated</p>
             <h6 class="notif-title">Successfully !</h6>
             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i class="fa-solid fa-thumbs-up" style={{fontSize:'25px'}}></i>
          </section> 
            
          
    </div>
  </div>
</div>
<div className='TCpopfade' id='del-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    
    <section class="notif notif-notice" id="successnotif">
             
             <p>Content&nbsp; Deleted</p>
             <h6 class="notif-title">Successfully !</h6>
             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i class="fa-solid fa-thumbs-up" style={{fontSize:'25px'}}></i>
          </section> 
            
          
    </div>
  </div>
</div>

 {/* --- Delete popup--- */}
 
  <div className="TCpopfade" id="modalDeleteForm" tabindex="-1" role="dialog">
{delDetail.map((e)=>
{
return<div>
  <div className="modal-dialog" role="document">
    <div className="modal-contentA">
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">Alert</h4>
        <button type="button" className="close" onClick={closedelForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

<form id='form'>
   <div className="modal-body mx-3">

        <div className="md-form mb-3">
            <div className='text-center'>
          <h5>Are you sure want to&nbsp;<span style={{color:"red"}}>Delete?</span></h5>
       
          </div>
        </div>
   </div>

      <div className="modal-footer d-flex justify-content-center">
       <button className='TC-logout-button'onClick={()=>delContent(e.id)}  type='submit'>Confirm</button>
        &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;<button className='TC-logout-button' onClick={Cancel} type='submit'>Cancel</button>
      </div>
      </form>
      
    </div>
  </div>
  </div>
  }
 )}
    </div>

 
 

       
    {pop? <div id="Loader">
<Oval
  height={40}
  width={50}
  color="black"
  wrapperStyle={{}}
  wrapperClass=""
  visible={true}
  ariaLabel='oval-loading'
  secondaryColor="gray"
  strokeWidth={2}
  strokeWidthSecondary={2}

/>
     </div>
 :null}
    </div>
    
  )
}
export default TcContentmain;